import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
// import { UserProfileData } from "../FetchAPI";
import { useAuth } from "../../Store/AuthContext";
// import { UserProfileData } from "../FetchAPI";

function Sidebar() {
  const { walletbalance, userRoll } = useAuth();
  // const [profileData] = UserProfileData(RendomTokenfetch);
  // const userRoll = profileData.role;
  // const VendorRoll = profileData.vendor_role;
  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    localStorage.removeItem("userid");
    localStorage.removeItem("userRoll");
    navigate("/login");
    // window.location.reload();
  };
  // const [isOpen, setIsopen] = useState(false);
  return (
    <>
      <div className={`user-sidebar usersitebarActive `}>
        {/* ${
          ShowUserSideBar === true ? "UserSidebarActive" : ""
        } */}
        <div className="sidebar-inner">
          <ul className="navigation">
            <li className="sidebarLink">
              <NavLink to="/deshboard" exact="true">
                {" "}
                <i className="fa fa-home" aria-hidden="true"></i> Dashboard
              </NavLink>
            </li>
            <li className="sidebarLink">
              <NavLink to="/profile" exact="true">
                <i className="fa fa-user" aria-hidden="true"></i>My Profile
              </NavLink>
            </li>
            {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/passbook" exact="true" className="d-block">
                  <i className="fa fa-money"></i>My Wallet
                  <span style={{ float: "right", color: "green",fontSize:'large' }}>
               
                    {" "}
                    ₹{walletbalance ? walletbalance : "0"}
                  </span>
                </NavLink>
              </li>
            ) : (
              ""
            )}
            <li className="sidebarLink">
              <NavLink to="/service-booking" exact="true">
                <i className="fa fa-bookmark" aria-hidden="true"></i>Service
                Booking
              </NavLink>
            </li>
            <li className="sidebarLink">
              <NavLink to="/vendor-request" exact="true">
                <i className="fa fa-reply" aria-hidden="true"></i>Send Vendor
                Request
              </NavLink>
            </li>
            {/* {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/claim-leads" exact="true">
                  <i className="fa fa-tasks"></i>Claim Leads
                </NavLink>
              </li>
            ) : (
              ""
            )} */}
            {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/leadAdd" exact="true">
                  <i className="fa fa-plus" aria-hidden="true"></i>Lead Add
                </NavLink>
              </li>
            ) : (
              ""
            )}
            {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/my-assign-lead" exact="true">
                  <i className="fa fa-file"></i>My Leads
                </NavLink>
              </li>
            ) : (
              ""
            )}

            {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/my-working-lead" exact="true">
                  <i className="fa fa-briefcase"></i>
                  Work Assigned to Me
                </NavLink>
              </li>
            ) : (
              ""
            )}

            {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/news-paper-schedule" exact="true">
                  <i className="fa fa-newspaper-o"></i>News Paper Schedule
                </NavLink>
              </li>
            ) : (
              ""
            )}
            {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/news-paper-add-view" exact="true">
                  <i className="fa fa-newspaper-o"></i>News Paper Add View
                </NavLink>
              </li>
            ) : (
              ""
            )}
            {/* {userRoll === "4" ? (
              <li className="sidebarLink">
                <NavLink to="/all-leads" exact="true">
                  <i className="fa fa-ticket"></i>All Leads
                </NavLink>
              </li>
            ) : (
              ""
            )} */}

            {/* <li className="sidebarLink">
              <NavLink to="/user-submission" exact="true">
                <i className="la la-paper-plane"></i>User Submission
              </NavLink>
            </li> */}
            {/* <li className="sidebarLink">
              <NavLink to="/forgot-password" exact="true">
                <i className="fa fa-ticket" aria-hidden="true"></i>Change Password
              </NavLink>
            </li> */}
            <li className="sidebarLink">
              <NavLink to="/login" exact="true" onClick={logout}>
                <i className="fa fa-sign-out" aria-hidden="true"></i>Logout
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
